import React from 'react';
import { Home, CheckSquare, Inbox, Compass, Plus } from 'lucide-react';
import { useWorkspace } from '../../context/WorkspaceContext';

export const MobileNav = ({ currentView, setCurrentView }) => {
  const { setIsQuickAddOpen } = useWorkspace();

  const navItems = [
    { id: 'workspace_home', label: 'Home', icon: <Home size={18} /> },
    { id: 'my_work', label: 'My Work', icon: <CheckSquare size={18} /> },
    { id: 'quick_add', label: 'Create', icon: <Plus size={20} strokeWidth={2.5} />, isAction: true },
    { id: 'inbox', label: 'Inbox', icon: <Inbox size={18} /> },
    { id: 'module_library', label: 'Modules', icon: <Compass size={18} /> }
  ];

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '60px',
        backgroundColor: 'var(--surface-card)',
        borderTop: '1px solid var(--border-subtle)',
        display: 'none', // Shown on mobile via CSS media query
        alignItems: 'center',
        justifyContent: 'space-around',
        zIndex: 90,
        boxShadow: '0 -4px 16px rgba(0, 0, 0, 0.15)'
      }}
      className="mobile-bottom-nav"
    >
      {navItems.map((item) => {
        if (item.isAction) {
          return (
            <button
              key={item.id}
              onClick={() => setIsQuickAddOpen(true)}
              aria-label="Create new task"
              style={{
                width: '46px',
                height: '46px',
                minWidth: '46px',
                minHeight: '46px',
                borderRadius: '999px',
                backgroundColor: 'var(--accent-container)',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                boxShadow: 'var(--shadow-raised-sm)',
                cursor: 'pointer',
                transform: 'translateY(-6px)'
              }}
              title="Create new task"
            >
              {item.icon}
            </button>
          );
        }

        const isActive = currentView === item.id;
        return (
          <button
            key={item.id}
            onClick={() => setCurrentView(item.id)}
            aria-label={item.label}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '48px',
              minHeight: '48px',
              gap: '3px',
              background: 'none',
              border: 'none',
              color: isActive ? 'var(--accent-teal)' : 'var(--text-muted)',
              fontSize: '10px',
              fontWeight: isActive ? '700' : '500',
              cursor: 'pointer',
              padding: '4px'
            }}
          >
            {item.icon}
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
